module.exports = __webpack_public_path__ + "static/assets/d889a872f3b0985b28fa872764172ef1.svg";